<template>
    <div class="border mb-2 p-2 d-flex bg-white">
        <div>
            <p class="mb-0">
                <strong>Start:</strong>
                <span class="mr-1">{{ event.start_at | date }}</span>
            </p>
            <p class="mb-0">
                <strong>End:</strong>
                <span class="mr-1">{{ event.end_at | date }}</span>
            </p>
            <p class="mb-0">
                <strong>Days:</strong>
                <span class="mr-1">{{ days }}</span>
            </p>
            <p class="mb-0">
                <strong>Type:</strong>
                <span class="mr-1">{{ event.type }}</span>
            </p>
            <p
                class="mb-0"
                v-if="event.user && !isCurrentUser"
            >
                <strong>User:</strong>
                <span class="mr-1">{{ event.user.name }}</span>
            </p>
            <p
                class="mb-0"
                v-if="event.user_id"
            >
                <strong>Status:</strong>
                <status :status="event.status" />
            </p>
        </div>
        <div class="text-right ml-auto mt-auto">
            <button
                type="button"
                class="btn btn-link"
                @click="$emit('edit', event)"
                v-if="event.user_id !== null"
            >
                Edit
            </button>
        </div>
    </div>
</template>
<script>
import Status from "../../../CalendarEventStatus.vue";
import AuthService from "../../../../services/AuthService";
import moment from "moment";
import {calculateDaysDiff} from "../../../../include/Calendar";
export default {
    components: {
        Status,
    },
    props: {
        event: {
            required: true,
            type: Object,
        },
    },
    computed: {
        isCurrentUser() {
            return AuthService.user.id === this.event.user_id;
        },
        days() {
            return calculateDaysDiff(this.event.start_at, this.event.end_at);
        },
    },
    emits: ["edit"],
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/office/admin/users/UserEventItem.vue